import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AlertProvider } from './components/AlertProvider.jsx';
import './styles/global.css';
import { applyBranding, loadBrandingFromStorage } from './utils/branding.js';

applyBranding(loadBrandingFromStorage());

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AlertProvider>
        <App />
      </AlertProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
